import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Avatar, Translation } from '../../common';

const NamedAvatar = ({
  name,
  picture,
  styles,
  className,
  withoutDescription,
  descriptionKey,
}) =>
  withoutDescription ? (
    <img
      src={picture}
      alt="avatar"
      className={classNames(
        styles['named-avatar__avatar_without-description'],
        className
      )}
    />
  ) : (
    <div className={classNames(styles['named-avatar__wrapper'], className)}>
      <Avatar
        alt="avatar"
        src={picture}
        className={styles['named-avatar__avatar']}
      />
      <div className={styles['named-avatar__label']}>
        <div className={styles['named-avatar__label-header']}>{name}</div>
        <Translation
          className={styles['named-avatar__label-description']}
          keyIfNoValue
        >
          {descriptionKey}
        </Translation>
      </div>
    </div>
  );

NamedAvatar.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  picture: PropTypes.string,
  styles: PropTypes.object,
};

export default NamedAvatar;
